import { DashboardState, ESdChangeReason, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { shouldShowPropertiesSkeleton } from "../../../../shared/utility/first-load-skeletons";
import { ApiManagementProperties } from "../api-management-panel/api-management-properties";
import { BluetoothActionsProperties } from "../datasource-panel/bluetooth-actions-properties";
import { DocumentParametersProperties } from "../document-parameters-panel/document-parameters-properties";
import RightPanelScrollEnd from "../right-panel-scroll-end";
import { ScheduledJobsProperties } from "../scheduled-jobs-panel/scheduled-jobs-properties";
import PropertiesSkeleton from "./properties-skeleton";
import { SelectedDiProperties } from "./selected-di-properties";

export interface IPropertiesWindowState {}

export interface IPropertiesWindowProps {}

class PropertiesWindow extends PureSdComponent<
  IPropertiesWindowProps & IWithSDProps & IWithContextProp,
  IPropertiesWindowState
> {
  constructor(props: IPropertiesWindowProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  getHeight = () => {
    if (this.props.sd.getVisibility(ViewPart.WfPropertiesPanel) === Visibility.Visible) {
      return "140px";
    }
    return "127px";
  };

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.PropertiesPanel) === Visibility.Visible && (
          <>
            <div style={{ width: "calc(100% - 4px)" }}>
              {this.props.sd.dashboardState !== DashboardState.design &&
                this.props.sd.dashboardState !== DashboardState.reportDesigner && (
                  <div className="kuika_right-panel__header">
                    <span className="kuika_right-panel__header__title">Properties</span>
                    <span style={{ float: "right" }}></span>
                  </div>
                )}
              <div
                // className={
                //   this.props.sd.getVisibility(ViewPart.WfPropertiesPanel) === Visibility.Visible
                //     ? "kuika_workflow-properties"
                //     : ""
                // }
                style={{
                  // `auto`, not `scroll`: no track when nothing overflows. The gutter stays reserved,
                  // so the column's 16px / 8px inset does not shift when a scrollbar appears.
                  overflowY: "auto",
                  scrollbarGutter: "stable",
                  // Measured: this box starts 150px below the viewport top (49px top bar +
                  // 101px of in-panel chrome — panel header + selected-component row). The old
                  // 132px was calibrated against the removed footer and left the box overflowing
                  // the viewport, so its last rows were unreachable. KOA-18354: the sub-bar is no
                  // longer subtracted — the panel sits beside that strip, not under it.
                  height:
                    this.props.sd.dashboardState === DashboardState.design ||
                    this.props.sd.dashboardState === DashboardState.reportDesigner
                      ? `calc(100vh - 150px)`
                      : `calc(100vh - ${this.getHeight()})`
                }}
              >
                {this.props.sd.getVisibility(ViewPart.PropertiesPanel) === Visibility.Visible &&
                  (shouldShowPropertiesSkeleton(this.props.sd) ? <PropertiesSkeleton /> : <SelectedDiProperties />)}

                {/* {this.props.sd.getVisibility(ViewPart.WfPropertiesPanel) === Visibility.Visible && (
                  <WorkflowProperties key={this.props.sd.selectedWfId} />
                )} */}

                {this.props.sd.getVisibility(ViewPart.ScheduledJobsPropertiesPanel) === Visibility.Visible && (
                  <ScheduledJobsProperties />
                )}

                {this.props.sd.getVisibility(ViewPart.ApiManagementPropertiesPanel) === Visibility.Visible && (
                  <ApiManagementProperties />
                )}

                {this.props.sd.getVisibility(ViewPart.DocumentParametersPropertiesPanel) === Visibility.Visible && (
                  <DocumentParametersProperties />
                )}

                {this.props.sd.getVisibility(ViewPart.BluetoothPropertiesPanel) === Visibility.Visible && (
                  <BluetoothActionsProperties />
                )}

                {/* Trailing breathing room, only while the content scrolls — shared with the styling
                    tab so both tabs' scroll bottoms stay equal. */}
                <RightPanelScrollEnd />
              </div>
            </div>
          </>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.WFStepMappingChange ||
      // Both of processWithSpinner's commits are stamped Loading, and PureSdComponent does
      // not wave that reason through — so without this the panel cannot observe
      // isProjectLoaded at all and its placeholder clears only because the tree happens to
      // arrive under LoadProject. A tree that lands empty (frame-provider force-creates a
      // root DI for legacy screens, in place and with no re-render) would otherwise leave
      // the placeholder up until the user selected something.
      changeReason === ESdChangeReason.Loading
    );
  };
}

const propertiesWindow = withContext<IPropertiesWindowProps>(withSD<IPropertiesWindowProps>(PropertiesWindow));
export { propertiesWindow as PropertiesWindow };
